export default __webpack_public_path__ + "static/media/smart-reports.6a5bb7d8.svg";